//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PurchaseQuotationCreateView from "@/views/Purchase/PchPurchaseQuotation/create"
import PurchaseQuotationListView from "@/views/Purchase/PchPurchaseQuotation/list"
import PurchaseQuotationUpdateView from "@/views/Purchase/PchPurchaseQuotation/update"

//
export default {
    path: "purchase_quotations",
    component: ModuleLayout,
    children: [
        {
            path: "",
            name: "purchase-quotation-list",
            component: PurchaseQuotationListView,
        },
        {
            path: "create",
            name: "purchase-quotation-create",
            component: PurchaseQuotationCreateView,
            meta: {
                title: "Crear cotización de compra",
            },
        },
        {
            path: ":id",
            name: "purchase-quotation-update",
            component: PurchaseQuotationUpdateView,
            meta: {
                title: "Datos de cotización de compra",
            },
        },
    ],
    meta: {
        title: "Cotizaciones de compras",
    },
}